import products from '../../functions/publicCheckoutProducts.json';

export const PUBLIC_CHECKOUT_PRODUCTS = Object.freeze(products);

export function getPublicCheckoutProduct(sku) {
  const key = String(sku || '').trim().toLowerCase();
  return PUBLIC_CHECKOUT_PRODUCTS[key] || null;
}
